import gql from 'graphql-tag'
import { AggregatePath } from '@/entities/interfaces'
import { ClosingReasonFragment } from '@/graphql/fragments/settings'

const structure: Array<AggregatePath> = [
  { name: 'reserves', title: 'Evaluations', aggregations: ['count'] },
]
const query = gql`
  ${ClosingReasonFragment}
  query aggregates($model: settings_closing_reason_bool_exp, $aggregate: sales_reserve_bool_exp, $order: [settings_closing_reason_order_by!]) {
    aggregates: settings_closing_reason(where: $model, order_by: $order) {
      ...ClosingReason
      reserves: reserves_aggregate(where: $aggregate) {
        aggregate {
          count(distinct:true)
        }
      }
    }
  }
`
export const aggregate = { structure, query }
export default aggregate
